export const GET_DATA = "GET_DATA";
export const GET_CHAINS_LIST = "GET_CHAINS_LIST";